import { SignatureType } from './SignatureType';

export class SignatureResponseData {

    base64signedDocument: string;
    dataToSign: string;
    cryptogram: string;
    fileType: string;
    signatureType: SignatureType;
    uuid: string;

    constructor() {
    }

}
